import { API, graphqlOperation } from 'aws-amplify';
// eslint-disable-next-line camelcase
import { unstable_batchedUpdates } from 'react-dom';
import * as subscriptions from '../../graphql/subscriptions';
import { addItemIfNotExists, findAndUpdate } from './Response';

export const subscribe = (owner = {}, key = '', callback = () => {}) => API.graphql(
  graphqlOperation(
    subscriptions[key], owner,
  ),
).subscribe(callback);

export const onCreateModel = (key, params, setDataSource, setLoading, onError) => subscribe(
  params,
  key,
  {
    next: (response) => {
      // Batch all subscription updates to prevent multiple re-renders
      // eslint-disable-next-line camelcase
      unstable_batchedUpdates(() => {
        setDataSource((prevDataSource) => addItemIfNotExists(response, key, prevDataSource));
      });
    },
    error: (err) => {
      if (onError) onError(err);
    },
  },
);

export const onUpdateModel = (key, params, setDataSource, setLoading, onError) => subscribe(
  params,
  key,
  {
    next: (response) => {
      // Batch all subscription updates to prevent multiple re-renders
      // eslint-disable-next-line camelcase
      unstable_batchedUpdates(() => {
        setDataSource((prevDataSource) => findAndUpdate(response, key, prevDataSource));
      });
    },
    error: (err) => {
      if (onError) onError(err);
    },
  },
);

const Subscription = {
  subscribe,
  onUpdateModel,
};

export default Subscription;
